/** What a folder's grow (FolderGrowList.ts) and its die (FolderTemplateList.ts)
 * both read, per template: each part's share of the cover — a width's of
 * the cover's width, a depth's or a height's of its height, as its template
 * measures it —, lengths of their own in mm. A flap's taper is its share of
 * its depth, at the start and the end of its edge as the grow walks it: a
 * left or a right edge from its top, a top or a bottom one from its left. */
export const FolderSpecList = {
  alieron: { panel: 210.1 / 220.4, bottom: 85 / 310, bottom_taper: [13.9 / 85, 14.5 / 85] },
  avant_garde: {
    side: 70 / 220,
    side_taper: [13 / 70, 0.2],
    bottom: 75 / 310,
    bottom_taper: [13 / 75, 11 / 75],
    // How much shorter the bottom flap is than the back
    bottom_short: 2,
  },
  // The pocket's width and height, from `pocket_top` down; the half round
  // flap `flap_inset` in from either side of the back
  bookman: { pocket: [209.8 / 220, 209 / 311], pocket_top: 102 / 311, flap_inset: 1 },
  brandon: {
    side: 75 / 231,
    side_taper: [0, 0],
    ends: 62 / 321,
    ends_taper: [0, 0],
    inset: [1, 5],
  },
  calibri: {
    pocket: [220 / 225, 131 / 310],
    pocket_top: 179 / 310,
    glue: 15,
    glue_taper: [7.7, 7.2],
  },
  castellar: { panel: 221.2 / 220, pocket: 190.4 / 220, glue: 19.6 },
  century_gothic: {
    side: 115.6 / 220,
    side_taper: [7.5 / 115.6, 7.3 / 115.6],
    ends: 78.5 / 310.8,
    ends_taper: [10.4 / 78.5, 10.6 / 78.5],
  },
  // The index tab, as deep as it is long past `tab_at` down the back
  didot: { tab: 26.9, tab_at: 89 / 310 },
  // The cover its lengths are for, in mm: the pocket's width and height,
  // how much shorter than the back the flap under it is and how deep, and
  // the lock tab's width and depth
  frutiger: { cover: [220, 302], pocket: [190, 199.8], flap: [30, 15], tab: [79.5, 15.2] },
  futura_light: { pocket: [170 / 220, 130 / 305], pocket_top: 175 / 305, glue: 15 },
  // The side flap from `side_top` down for `side_length`, cut back at its top
  // as far as `side_cut`, never closer than `side_least` to its bottom
  hetfy: {
    side: 100.5 / 225,
    side_top: 66.2 / 314.8,
    side_length: 248.6 / 314.8,
    side_cut: 194.3 / 314.8,
    side_least: 10,
    bottom: 85.5 / 314.8,
    bottom_taper: 36.7 / 85.5,
    bottom_short: 3.5,
  },
  // The back `extra` wider than the front
  impact: {
    side: 49.7 / 235.1,
    ends: 46.8 / 332.7,
    ends_taper: [0, 71.6 / 66.8],
    inset: [3, 5.6],
    extra: 18.1,
  },
  rotis: {
    panel: 221.2 / 220,
    back: { pocket: 190.4 / 220, glue: 19.6 },
    front: { pocket: 190.1 / 220, glue: 14.9 },
  },
  trinite: {
    side: 43.1 / 219.3,
    side_taper: 17.7 / 43.1,
    bottom: 34.6 / 300.1,
    bottom_taper: 17.6 / 34.6,
    bottom_short: 2.6,
  },
  univers: {
    back: { pocket: 190.2 / 220, glue: 15 },
    front: { pocket: 190.1 / 220, glue: 15 },
  },
  // The rounded pocket glued under a cover (castellar, rotis, univers): its
  // depth
  glued_pocket: { depth: 130 / 305.2 },
  // Pockets under both covers (rotis, univers) share the spine: the top of
  // each cover's stack — its pocket, or the panel over it — on a gusset
  // half of it, so many sheets short, clear of the other's
  shared_spine: 1,
  // A pocket or a flap under a panel (alieron, castellar, rotis) on a gusset
  // so many sheets short of the panel's, its walls inside the panel's
  under_panel: 2,
} as const
